<section style="margin-top: -20px;">
  <div class="row text-left">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">

            <div class="row">
              <div [class]="parametrosTabla.clasePaginator + ' d-flex justify-content-start align-items-center'">


                       <button type="button" class="btn btn-info mt-1 ml-1 btn-animate"
                               *ngIf="parametrosTabla.botonAgregarNuevo===true"
                               (click)="emit(this.constants.AGREGAR)" ngbTooltip="{{parametrosTabla.botonAgregar.titulo}}"><i
                         class="ft-plus"></i></button>

                       <button class="btn btn-success mt-1 ml-1 btn-animate"
                               *ngIf="parametrosTabla.botonExportar!=undefined && parametrosTabla.botonExportar==true"
                               style="margin-left: 1px;" type="button" ngbTooltip="Exportar tabla en Excel"
                               (click)="exportTable()">
                         <i class="bi bi-file-earmark-excel-fill"></i>
                       </button>

                       <button class="btn btn-secondary mt-1 ml-1 btn-animate"
                               *ngIf="parametrosTabla.botonExportarGeneral!=undefined && parametrosTabla.botonExportarGeneral==true"
                               style="margin-left: 1px;" type="button" ngbTooltip="Reporte General"
                               (click)="exportTableColumnas()">
                         <i class="bi bi-file-earmark-excel-fill"></i>
                       </button>


                       <button class="btn btn-secondary mt-1 ml-1 btn-animate"
                               style="margin-left: 1px;" type="button" ngbTooltip="Impresión tabla en PDF"
                               (click)="imprimirTabla()">
                         <i class="bi bi-printer-fill"></i>
                       </button>

                       <button class="btn btn-info mt-1 ml-1 btn-animate"
                               *ngIf="parametrosTabla.botonPDF!=undefined && parametrosTabla.botonPDF==true"
                               style="margin-left: 1px;" type="button" ngbTooltip="Generar Reporte PDF"
                               (click)="emit(this.constants.PDF)">
                         <i class="bi bi-file-pdf-fill"></i>
                       </button>

                       <button class="btn btn-warning mt-1 ml-1 btn-animate"
                               *ngIf="parametrosTabla.botonActualizar!=undefined && parametrosTabla.botonActualizar==true"
                               ngbTooltip="Actualizar datos en tabla" style="margin-left: 1px;" type="button"
                               (click)="emit(this.constants.ACTUALIZAR_TABLA)">
                  <span *ngIf="this.isLoading"
                        class="spinner-border spinner-border-sm mr-1"></span><i class="ft-refresh-ccw"></i>
                       </button>

                       <button class="btn btn-info mt-1 ml-1 btn-animate"
                               *ngIf="parametrosTabla.botonBuscar!=undefined && parametrosTabla.botonBuscar==true"
                               style="margin-left: 1px;" type="button" ngbTooltip="Generar Búsqueda"
                               (click)="emit(this.constants.GENERAR_BUSQUEDA)">
                         <i class="bi bi-search"></i>
                       </button>

                       <div *ngIf="parametrosTabla.botonDescarga!=undefined && parametrosTabla.botonDescarga==true"
                            style="display: inline;">
                         <button class="btn btn-dark mt-1 ml-1 btn-animate" ngbTooltip="Descarga"
                                 style="margin-left: 1px;" type="button" (click)="emit(this.constants.DESCARGAR)">
                           <i class="ft-download"></i>
                         </button>
                       </div>

                       <div *ngIf="parametrosTabla.botonTipoCambio!=undefined && parametrosTabla.botonTipoCambio==true"
                            style="display: inline;">
                         <button class="btn btn-info mt-1 ml-1 btn-animate" *appIsGranted="Control.TIPO_DE_CAMBIO_BOTON"
                                 ngbTooltip="Tipo Cambio"
                                 style="margin-left: 1px;" type="button" (click)="emit(this.constants.TIPO_CAMBIO)">
                           <i class="ft-dollar-sign"></i>
                         </button>
                       </div>


                       <div *ngIf="parametrosTabla.botonFusionar!=undefined && parametrosTabla.botonFusionar==true"
                            style="display: inline;">
                         <button class="btn btn-dark mt-1 ml-1 btn-animate" ngbTooltip="Fusionar"
                                 style="margin-left: 1px;" type="button" (click)="emit(this.constants.FUSIONAR)">
                           <i class="ft-minimize-2"></i>
                         </button>
                       </div>

                      <!-- Esto permite ver los botones en la parte superior de la tabla
                       <div *ngIf="selectedRow!==null" class="d-flex gap-2 mt-1 ml-1">
                         <div *ngFor="let columna of displayedColumns; let i = index">
                           <div *ngIf="this.formatColumn[i]===this.constants.CONTROL && displayColumn(selectedRow,columna) && isGranted(columna)" class="mr-1">
                             <button class="btn btn-outline-secondary" ngbTooltip="{{columna}}" (click)="emit(columna,selectedRow)">
                               <i [class]="setIconColumn(columna)"></i>
                             </button>
                           </div>
                         </div>
                       </div>
                       -->
              </div>

              <div [class]="parametrosTabla.clasePaginator">
                <mat-paginator #idpaginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                               [pageIndex]="pageIndex" (page)="pageEvent = handlePage($event)"></mat-paginator>
              </div>


            </div>

            <mat-form-field appearance="fill" style="width: 100%;">
              <mat-label>Buscar....</mat-label>
              <input matInput (keyup)="filterTable($event)" placeholder="Buscar" #input autocomplete="off">
            </mat-form-field>

            <div #idExportar class="tabla-scroll-wrapper">
              <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
                     class="table table-striped example-container sticky-table mat-elevation-z8" style="width: 100%;">

                <div *ngFor="let columna of displayedColumns; let i = index ">

                  <ng-container matColumnDef="{{columna}}">


                    <div *ngIf="this.formatColumn[i]!==this.constants.CONTROL">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header
                          [class]="displayedColumns[i] + ' sticky-header'">{{dataNames[i]}}</th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.TEXT">
                      <td mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]]}}</td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.NUMBER">
                      <td style="text-align: center; border:solid #2f8be6 2.5px;" mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]]}}</td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>


                    <div *ngIf="this.formatColumn[i]===this.constants.PORCENTAJE">
                      <td style="text-align: center; border:solid #2f8be6 2.5px;" mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]] | percent:'1.2-2'}}</td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>


                    <div *ngIf="this.formatColumn[i]===this.constants.CURRENCY">
                      <td mat-cell *matCellDef="let element" [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)"
                          style="text-align: right; border:solid #EB984E 2.5px;">
                        <div *ngIf="displayCurrency(element,columna)">
                          {{element[displayedColumns[i]] | currency: 'MXN'}}
                        </div>
                      </td>

                      <th mat-footer-cell *matFooterCellDef style="text-align: right">{{sumTotal(columna) === 0 ? '-' : (sumTotal(columna)| number:'1.2-2')}} </th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.DATE">
                      <td mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]] | date:'dd-MMM-yyyy'}}</td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.DATETIME">
                      <td mat-cell *matCellDef="let element"
                          [class]="setBackground(element,columna)"
                          (mouseup)="detectRightMouseClick($event,element)">{{element[displayedColumns[i]] | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>

                    <!-- Controles -->
                    <div *ngIf="this.formatColumn[i]===this.constants.CONTROL">
                      <th mat-header-cell *matHeaderCellDef class="ignoreprint sticky-header"></th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.CONTROL">
                      <td mat-cell *matCellDef="let element" style="width: 5px !important; padding: 0px !important;"
                          class="ignoreprint">
                        <a class="p-0 text-center mr-1" (click)="emit(columna,element)"
                           *ngIf="displayColumn(element,columna) && isGranted(columna)">
                          <i ngbTooltip="{{columna}}" container="body" [class]="setIconColumn(columna)"></i>
                        </a>
                      </td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.CHECK">
                      <td mat-cell *matCellDef="let element" style="width: 5px !important;" class="ignoreprint">
                        <input type="checkbox" (click)="checkedBox($event,element)"
                               *ngIf="displayColumn(element,columna)" [checked]="element.selected == true">
                      </td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>

                    <div *ngIf="this.formatColumn[i]===this.constants.CONICONOPOP">
                      <td mat-cell *matCellDef="let element" style="text-align: center;" class="ignoreprint">
                        <i class="{{parametrosTabla.formatos[element[displayedColumns[i]]].split('&&&')[0]}}"
                           ngbTooltip="{{parametrosTabla.formatos[element[displayedColumns[i]]].split('&&&')[1]}}"></i>
                      </td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>

                    <!-- Semaforo -->
                    <div *ngIf="this.formatColumn[i]===this.constants.SEMAFORO">
                      <td mat-cell *matCellDef="let element"
                          style="text-align: center;" class="ignoreprint">
                        <i placement="bottom"
                           ngbTooltip="{{parametrosTabla.tooltipSemaforo!== undefined ? (parametrosTabla.tooltipSemaforo[(element[displayedColumns[i]])]) : ''}}"
                           [class]="(element[displayedColumns[i]] == 0 ? 'ft-check font-medium-4 mr-2 success ':
                         ( element[displayedColumns[i]] == 1 ? 'ft-info font-medium-4 mr-2 warning' :
                         ( element[displayedColumns[i]] == 2 || element[displayedColumns[i]] == 3 || element[displayedColumns[i]] == 4   ? 'ft-alert-triangle font-medium-4 mr-2 danger' : '')))"></i>
                      </td>
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>


                    <!--Footer-->
                    <!--
                    <div
                      *ngIf="this.parametrosTabla.conTotales!==undefined && this.parametrosTabla.conTotales === true && this.displayFooter[i]===this.constants.VACIO">
                      <th mat-footer-cell *matFooterCellDef></th>
                    </div>
                    <div
                      *ngIf="this.parametrosTabla.conTotales!==undefined && this.parametrosTabla.conTotales === true && this.displayFooter[i]===this.constants.SUMA">
                      <th mat-footer-cell *matFooterCellDef
                          style="text-align: right;"> {{sumTotal(columna) === 0 ? '-' : (sumTotal(columna)| number:'1.2-2')}} </th>
                    </div>
                    <div
                      *ngIf="this.parametrosTabla.conTotales!==undefined && this.parametrosTabla.conTotales === true && this.displayFooter[i]===this.constants.MINIMO">
                      <th mat-footer-cell *matFooterCellDef
                          style="text-align: right;"> {{obtenerMin(columna) === 0 ? '-' : (obtenerMin(columna)| number:'1.2-2')}} </th>
                    </div>
                    <div
                      *ngIf="this.parametrosTabla.conTotales!==undefined && this.parametrosTabla.conTotales === true && this.displayFooter[i]===this.constants.MAXIMO">
                      <th mat-footer-cell *matFooterCellDef
                          style="text-align: right;"> {{obtenerMax(columna) === 0 ? '-' : (obtenerMax(columna)| number:'1.2-2')}} </th>
                    </div>
                    <div
                      *ngIf="this.parametrosTabla.conTotales!==undefined && this.parametrosTabla.conTotales === true && this.displayFooter[i]===this.constants.TITULOTOTALES">
                      <th mat-footer-cell *matFooterCellDef>TOTALES</th>
                    </div> -->

                  </ng-container>
                </div>


                <div *ngIf="parametrosTabla.twoHeaders!==undefined && parametrosTabla.twoHeaders === true">
                  <ng-container *ngFor="let secondHea of parametrosTabla.beforeHeader; let ind= index"
                                matColumnDef="{{secondHead[ind]}}">
                    <th mat-header-cell *matHeaderCellDef [colSpan]="secondHea.colspan" style="text-align: center; height: 0 !important;
                        {{ ind == secondHead.length -1?'' :'border-right: 2px solid #474748'}}"> {{secondHea.titulo}}</th>
                  </ng-container>
                  <ng-container>
                    <tr mat-header-row *matHeaderRowDef="secondHead; sticky: true"
                        style="text-align: center; height: 0 !important;">
                    </tr>
                  </ng-container>
                </div>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
                    [ngClass]="{alternate: even, 'selected-row': selectedRow === row}" (click)="selectedRow = row"></tr>

                <div *ngIf="this.parametrosTabla.conTotales!==undefined && this.parametrosTabla.conTotales === true">
                  <tr mat-footer-row *matFooterRowDef="displayedColumns;" style="height: 0"></tr>
                </div>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="20" style="text-align: center;">No hay informacion para
                    mostrar {{input.value}}</td>

                </tr>

              </table>

              <div *ngIf="this.parametrosTabla.dataSource.length > 0 && this.isLoading"
                   style="display: flex; justify-content: center; align-items: center; margin-top: 15px;">
                <mat-progress-spinner
                  color="primary"
                  mode="indeterminate"
                  [diameter]="30">
                </mat-progress-spinner>
                <span class="ml-1">Mostrando Datos</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<ngx-spinner style="color:#ffffff;">Cargando</ngx-spinner>


<div class="contextmenu" [ngStyle]="this.rightPanelStyle" (clickOutside)="closeContextMenu()"
     (mouseleave)="closeContextMenu()">
  <ul class="menu">
    <div *ngFor="let columna of displayedColumns; let i = index ">
      <li
        *ngIf="this.formatColumn[i]===this.constants.CONTROL &&
        this.optionSelectedMenuContext!== undefined &&
        displayOptionMenuContext(columna) && isGranted(columna)">
        <a (click)="emit(columna,this.optionSelectedMenuContext)">
          <i [title]="columna" [class]="setIconColumn(columna)"></i>{{columna}}
        </a>
      </li>
    </div>
  </ul>
</div>

<app-exportar-excel *ngIf="this.parametrosTabla.dataSource.length>0"
                    #modalExportarExcel [tableNative]="this.table"
                    [lengthData]="this.parametrosTabla.dataSource.length"
                    [displayedColumns]=" this.parametrosTabla.displayedColumns"
                    [formatColumn]=" this.parametrosTabla.formatColumn"
                    [dataSource]="this.parametrosTabla.dataSource"
                    [dataNames]="this.parametrosTabla.dataNames"
                    [tableBD]="parametrosTabla.tabla"></app-exportar-excel>
